import { render } from "./NotFound.vue?vue&type=template&id=2f76fe0e"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=2f76fe0e&lang=css"
script.render = render

export default script